module.exports = __webpack_public_path__ + "static/media/instagram-mobile.60871533.svg";